import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getTranslations, getByPath } from '../../content/siteContentUtils';

var bgimg1 = require('./../../images/background/cross-line2.png');

const fallbackServicesText = [
    {
        count: '01',
        title: 'Çelik Kapı Üretimi',
        description: 'Yüksek güvenlikli, dayanıklı ve estetik çelik kapı modellerimizle evinizi koruma altına alıyoruz.',
        linkLabel: 'Detaylı Bilgi'
    },
    {
        count: '02',
        title: 'Montaj ve Kurulum',
        description: 'Uzman teknik ekibimizle, sipariş verdiğiniz kapıların nakliye ve montaj işlemlerini titizlikle gerçekleştiriyoruz.',
        linkLabel: 'Detaylı Bilgi'
    },
    {
        count: '03',
        title: 'Özel Tasarım',
        description: 'Mevcut modellerin dışında, zevkinize ve mekanınıza uygun özel ölçü ve tasarım kapı seçenekleri sunuyoruz.',
        linkLabel: 'Detaylı Bilgi'
    },
    {
        count: '04',
        title: 'Bina Giriş Kapıları',
        description: 'Apartman, site ve iş merkezleri için uzun ömürlü, şık ve güvenli bina giriş kapısı çözümleri.',
        linkLabel: 'Detaylı Bilgi'
    },
    {
        count: '05',
        title: 'Yangın Kapıları',
        description: 'Tüm güvenlik yönetmeliklerine uygun, sertifikalı ve dayanıklı yangın çıkış kapıları.',
        linkLabel: 'Detaylı Bilgi'
    },
    {
        count: '06',
        title: 'Satış Sonrası Destek',
        description: 'Satış sonrasında da bakım, onarım ve yedek parça desteği ile yanınızdayız.',
        linkLabel: 'Detaylı Bilgi'
    }
];

const fallbackServicesConfig = [
    { iconClass: 'fa fa-industry' },
    { iconClass: 'fa fa-wrench' },
    { iconClass: 'fa fa-pencil' },
    { iconClass: 'fa fa-building-o' },
    { iconClass: 'fa fa-fire-extinguisher' },
    { iconClass: 'fa fa-life-ring' }
];

const legacyServiceIcons = new Set([
    'flaticon-sketch',
    'flaticon-stairs',
    'flaticon-window',
    'flaticon-skyline',
    'flaticon-bed',
    'flaticon-door',
]);

class Services1 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const t = getTranslations(content);
        const section = t?.pages?.home?.services || {};
        const textItems = Array.isArray(section.items) ? section.items : [];
        const configItems = getByPath(content, 'home.services.items', []);

        const services = fallbackServicesText.map((fallback, index) => {
            const merged = {
                ...fallback,
                ...(textItems[index] || {}),
                ...(fallbackServicesConfig[index] || {}),
                ...(((Array.isArray(configItems) ? configItems[index] : null) || {})),
            };

            const iconClass = (merged.iconClass || '').trim();
            if (!iconClass || legacyServiceIcons.has(iconClass)) {
                merged.iconClass = getByPath(fallbackServicesConfig, `${index}.iconClass`, 'fa fa-life-ring');
            }

            return merged;
        });

        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b50 bg-gray">
                    <div className="section-content">
                        <div className="container">
                            <div className="section-head">
                                <div className="sx-separator-outer separator-left">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        <h3 className="sep-line-one ">{section.title || 'Tüm Hizmetler'}</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {services.map((item, index) => (
                                    <div className="col-lg-4 col-md-6 col-sm-12 m-b30" key={index}>
                                        <div className="sx-icon-box-wraper icon-count-2-outer">
                                            <div className="icon-count-2 bg-white">
                                                <span className="icon-count-number">{item.count}</span>
                                                <div className="icon-xl inline-icon m-b5 scale-in-center">
                                                    <span className="icon-cell"><i className={item.iconClass || 'fa fa-life-ring'} /></span>
                                                </div>
                                                <div className="icon-content">
                                                    <h4 className="sx-tilte">{item.title}</h4>
                                                    <p>{item.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l50 text-uppercase">
                        <strong>{section.highlightText || 'Hizmetler'}</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default Services1;
